var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty1Step3G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_31691)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_161_31691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_161_31691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 34.15H26.75C27.55 34.15 28.25 33.85 28.85 33.25C29.45 32.65 29.75 31.95 29.75 31.15V26.8C29.75 25.9 29.5083 25.1917 29.025 24.675C28.5417 24.1583 27.9667 23.9 27.3 23.9C27.9667 23.9 28.5417 23.675 29.025 23.225C29.5083 22.775 29.75 22.0833 29.75 21.15V16.85C29.75 16.05 29.45 15.35 28.85 14.75C28.25 14.15 27.55 13.85 26.75 13.85H18.25V16.85H26.75V22.4H22.4V25.4H26.75V31.15H18.25V34.15ZM9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H39C39.8 6 40.5 6.3 41.1 6.9C41.7 7.5 42 8.2 42 9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9Z",
    fill: "#0BAB47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_31691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Step3G);
export default __webpack_public_path__ + "static/media/Property 1=Step-3-G.cca882b349eab89c3b062decbf76432d.svg";
export { ForwardRef as ReactComponent };